import { Form, Spin } from 'antd';
import Box from 'components/Box';
import Empty from 'components/Empty';
import React, { forwardRef, useImperativeHandle, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
import { getTimeSections } from '../QuickBookingV2/helpers';

type Ref = {
  setLoading: (value: boolean) => void;
};
type Props = {
  value?: string;
  onChange?: (value?: string) => void;
  detailApt?: boolean;
};
export const useStartTimesRef = () => useRef<Ref>(null);
const StartTimes = forwardRef<Ref, Props>(({ value, onChange = () => undefined, detailApt }, ref) => {
  const [loading, setLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    setLoading,
  }));

  return (
    <Spin spinning={loading} >
      <Form.Item name={'time-slots'} noStyle>
        <TimeSlots detailApt={detailApt} loading={loading} dateValue={value} onChangeDate={onChange} />
      </Form.Item>
    </Spin>
  );
});
StartTimes.displayName = 'StartTimes';
export default StartTimes;
const TimeSlots = ({ detailApt, loading, value: timeLines = [], dateValue, onChangeDate }: { value?: string[], dateValue?: string, onChangeDate: (value: string) => void; loading?: boolean, detailApt?: boolean }) => {
  const sections = useMemo(() => getTimeSections(timeLines), [timeLines]);
  if (!loading && !timeLines.length) return (
    <Box display='flex' alignItems='center' justifyContent='center'>
      <Empty description='Not Available' />
    </Box>
  );
  return (
    <ContainerBox>
      {sections.morning.length > 0 && <div className='time-slot-section'>
        <div className="section-sublabel">Morning</div>
        <StartTimeChange value={dateValue} timeslots={sections.morning} onChange={onChangeDate} />
      </div>}
      {sections.afternoon.length > 0 && <div className='time-slot-section'>
        <div className="section-sublabel">Afternoon</div>
        <StartTimeChange value={dateValue} timeslots={sections.afternoon} onChange={onChangeDate} />
      </div>}
      {sections.evening.length > 0 && <div className='time-slot-section'>
        <div className="section-sublabel">Evening</div>
        <StartTimeChange value={dateValue} timeslots={sections.evening} onChange={onChangeDate} />
      </div>}
    </ContainerBox>
  );
};
const StartTimeChange = ({ value, onChange, timeslots = [] }: { value?: string, onChange?: (value: string) => void; timeslots?: string[] }) => {
  return (
    <Container>
      {timeslots.map((o: string) => (
        <button type='button' onClick={() => onChange?.(o)} key={o} className={`start-time-item ${value === o ? 'active' : ''}`}>
          <span>{o}</span>
        </button>
      ))}
    </Container>
  );
};

const ContainerBox = styled(Box)`

.time-slot-section {
  display: flex;
  padding: 8px 16px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  background: #F6F7FC;
}

.section-sublabel {
  color: #505050;
  text-align: left;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  align-self: stretch;
  gap: 8px;
  zoom: 0.85;
  .start-time-item {
    display: flex;
    padding: 16px 8px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 5px;
    border: 1px solid #CCD4DC;
      background: #FFF;
    span {
      color: #505050;
      text-align: center;
      font-family: Poppins;
      font-size: 22px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    &.active {
      border: 1px solid #2D6772;
      background: #2D6772;
      span {
        color: #FFF;
      }
    }
  }
`;